import {useQuery} from '@apollo/react-hooks';
import {NetworkStatus} from 'apollo-client';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {
    GetSchedulerStats as GetSchedulerStatsQuery,
    GetSchedulerStats_schedulerStats as SchedulerStats,
    GetSchedulerStatsVariables,
    SchedulerStatsInput,
} from 'nutshell-graphql-types';

import GET_SCHEDULER_STATS from '../queries/get-scheduler-stats.graphql';

export const useGetSchedulerStats = (
    input: SchedulerStatsInput
): {
    schedulerStats: SchedulerStats | null | undefined;
    isLoading: boolean;
    isFirstLoad: boolean;
    error: string | null | undefined;
} => {
    const {loading, data, error, networkStatus} = useQuery<
        GetSchedulerStatsQuery,
        GetSchedulerStatsVariables
    >(GET_SCHEDULER_STATS, {
        variables: {
            input,
        },
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
    });

    const isChangingInput = networkStatus === NetworkStatus.setVariables;

    return {
        schedulerStats: data && data.schedulerStats,
        isLoading: loading && (!data || isChangingInput),
        isFirstLoad: isFirstLoad(networkStatus),
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
